export default __webpack_public_path__ + "static/media/zoom.1bc8007f.svg";